export interface TeamRole {
  id: string;
  slug: string;
  label: string;
}

// Roles de sistema da apogeu-api: seeds com GUIDs determinísticos
// (RoleConfiguration.cs). A API não expõe um endpoint de roles; owner é a role
// de quem aceita o convite de onboarding e não é convidável.
export const TEAM_ROLES: TeamRole[] = [
  { id: "22222222-2222-7222-8222-222222222222", slug: "admin", label: "Admin" },
  { id: "33333333-3333-7333-8333-333333333333", slug: "staff", label: "Staff" },
  { id: "44444444-4444-7444-8444-444444444444", slug: "coach", label: "Coach" },
];